export enum VAlign {
	Top,
	Middle,
	Bottom
}
